/*
  Пояснение на месте кнопок сборки, когда их закрыл ярус участия (строка 127 реестра,
  30.10.2026): на полном обслуживании документы готовит агент сопровождения ООО «Арбитр».

  Без пояснения блок просто исчезал бы, и человек искал бы кнопку «Сформировать пакет»,
  которой для его организации нет по условиям договора, а не из-за поломки.
*/

import { Notice } from './Common.jsx'

export default function AssemblyClosedNote() {
  return (
    <Notice kind="warn" wide>
      <div className="notice__what">
        У вашей организации полное обслуживание: документы готовит платформа.
      </div>
      <div className="notice__do">
        Заявления, уведомления и иски формирует агент сопровождения ООО «Арбитр». Если нужно
        собирать их самим, попросите изменить ярус участия.
      </div>
    </Notice>
  )
}
